import styled from "styled-components";
import { device } from "./Device";

export const TickerText = styled.p`
  margin: 0;
  color: white;
  white-space: nowrap;
  padding-right: 0.3vw;
  display: flex;
  align-items: center;

  @media ${device.mobileS} {
    font-size: 2.3vh;
    margin-bottom: 1vh;
  }

  @media ${device.mobileM} {
    font-size: 2.4vh;
    margin-bottom: 1vh;
  }

  @media ${device.mobileL} {
    font-size: 2.4vh;
    margin-bottom: 1vh;
  }

  @media ${device.tablet} {
    font-size: 2.4vh;
    margin-bottom: 1vh;
  }

  @media ${device.laptop} {
    font-size: 3.1vh;
    margin-bottom: -1.2vh;
  }

  @media ${device.laptopL} {
    font-size: 3.4vh;
    margin-bottom: -1.5vh;
  }

  @media ${device.desktop} {
    font-size: 3.3vh;
    margin-bottom: -1.5vh;
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: white;
  letter-spacing: 1%;

  @media ${device.mobileS} {
    font-size: 3.9vh;
  }

  @media ${device.mobileM} {
    font-size: 4.2vh;
  }

  @media ${device.mobileL} {
    font-size: 4vh;
  }

  @media ${device.tablet} {
    font-size: 4.9vh;
  }

  @media ${device.laptop} {
    font-size: 6.3vh;
  }

  @media ${device.laptopL} {
    font-size: 6.8vh;
  }

  @media ${device.desktop} {
    font-size: 7.2vh;
  }
`;

export const Subtitle = styled.h2`
  margin: 0;
  color: white;
  letter-spacing: 2%;
  width: 100%;
  text-align: right;

  @media ${device.mobileS} {
    font-size: 2.8vh;
    margin-top: 2.9vh;
  }

  @media ${device.mobileM} {
    font-size: 2.9vh;
    margin-top: 2.4vh;
  }

  @media ${device.mobileL} {
    font-size: 2.6vh;
    margin-top: 2vh;
  }

  @media ${device.tablet} {
    font-size: 3vh;
    margin-top: 0vh;
  }

  @media ${device.laptop} {
    margin-top: 1vh;
    font-size: 4.1vh;
  }

  @media ${device.laptopL} {
    margin-top: 1vh;
    font-size: 4.6vh;
  }

  @media ${device.desktop} {
    margin-top: 1vh;
    font-size: 5vh;
  }
`;

export const Slogan = styled.p`
  color: white;
  letter-spacing: 1%;
  font-style: italic;
  text-align: right;

  @media ${device.mobileS} {
    font-size: 2.5vh;
  }

  @media ${device.mobileM} {
    font-size: 2.4vh;
  }

  @media ${device.mobileL} {
    font-size: 2.2vh;
  }

  @media ${device.tablet} {
    font-size: 2.5vh;
  }

  @media ${device.laptop} {
    font-size: 3.1vh;
  }

  @media ${device.laptopL} {
    font-size: 3.3vh;
  }

  @media ${device.desktop} {
    font-size: 3.4vh;
  }
`;

export const MeetupText = styled.p`
  color: white;
  margin: 0;

  @media ${device.mobileS} {
    font-size: 1.6vh;
  }

  @media ${device.mobileM} {
    font-size: 1.7vh;
  }

  @media ${device.mobileL} {
    font-size: 1.6vh;
  }

  @media ${device.tablet} {
    font-size: 2.1vh;
  }
`;

export const PriceText = styled.p`
  color: white;
  font-size: 2.5vh;
  font-weight: 700;

  @media ${device.laptop} {
    font-size: 3.5vh;
  }
`;

export const StripeMessage = styled.h1`
  text-align: center;
  margin-top: 2vh;
  font-size: 2vh;

  @media ${device.laptop} {
    font-size: 4.5vh;
  }
`;

export const ProductTitle = styled.h3`
  font-size: 2vh;
  color: white;
  text-align: center;

  @media ${device.laptop} {
    font-size: 3vh;
  }
`;
